import React, { useState, useEffect } from 'react';
import { db } from '../firebase/firebase-config';
import { collection, addDoc, getDocs, deleteDoc, doc, query, orderBy } from 'firebase/firestore';
import { Play, Trash2, CheckCircle2, AlertCircle, HelpCircle } from 'lucide-react';

const VideoManager = () => {
  const [videoTitle, setVideoTitle] = useState('');
  const [videoUrl, setVideoUrl] = useState('');
  const [videos, setVideos] = useState([]);
  const [notification, setNotification] = useState({ show: false, message: '', type: '' });
  const [deleteModal, setDeleteModal] = useState({ show: false, id: null });

  const showPopup = (message, type) => {
    setNotification({ show: true, message, type });
    setTimeout(() => setNotification({ show: false, message: '', type: '' }), 3000);
  };

  const fetchVideos = async () => {
    const q = query(collection(db, "videos"), orderBy("createdAt", "desc"));
    const querySnapshot = await getDocs(q);
    setVideos(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
  };

  useEffect(() => { fetchVideos(); }, []);

  const handleAddVideo = async (e) => {
    e.preventDefault();
    if (!videoTitle || !videoUrl) return showPopup("Lütfen tüm alanları doldurunuz.", "error");

    try {
      await addDoc(collection(db, "videos"), {
        title: videoTitle,
        url: videoUrl,
        createdAt: new Date()
      });
      setVideoTitle(''); setVideoUrl('');
      fetchVideos();
      showPopup("Video başarıyla eklendi.", "success");
    } catch (err) {
      showPopup("Hata oluştu.", "error");
    }
  };

  return (
    <div className="slider-manager-container">
      {notification.show && (
        <div className={`notification-popup ${notification.type}`}>
          {notification.type === 'success' ? <CheckCircle2 size={20} /> : <AlertCircle size={20} />}
          <span>{notification.message}</span>
        </div>
      )}

      {/* Video Ekleme Formu */}
      <form className="upload-section" onSubmit={handleAddVideo}>
        <div className="form-grid">
          <div className="input-group full">
            <label>Video Başlığı</label>
            <input type="text" value={videoTitle} onChange={(e) => setVideoTitle(e.target.value)} placeholder="Örn: Fabrika Tanıtım Filmi" />
          </div>
          <div className="input-group full">
            <label>YouTube Video Linki</label>
            <input type="text" value={videoUrl} onChange={(e) => setVideoUrl(e.target.value)} placeholder="https://www.youtube.com/watch?v=..." />
          </div>
        </div>
        <button type="submit" className="upload-confirm-btn">Video Ekle</button>
      </form>

      <div className="divider"><span>Sistemdeki Videolar</span></div>

      <div className="slider-preview-grid">
        {videos.map((vid) => (
          <div key={vid.id} className="preview-card-full">
            <div className="video-preview-box">
               <Play size={40} color="#2ecc71" />
            </div>
            <div className="card-details">
              <h4>{vid.title}</h4>
              <p style={{fontSize: '11px'}}>{vid.url}</p>
              <button onClick={() => setDeleteModal({show: true, id: vid.id})} className="delete-btn-simple"><Trash2 size={16}/> Kaldır</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VideoManager;